import Auth from "./auth";
import Emitter, { EventTypes } from "../utils/Emitter";
import axios from "axios";
import { Notyf } from "notyf";
import { cors } from "../utils/Cors";

const notyf = new Notyf({
  position: {
    x: "center",
    y: "cneter",
  },
});
const toast = {
  error(message) {
    notyf.error(message);
  },
};
// Keep the body callers already expect, but tag the status so Auth.tryRefresh
// can tell a rejected session apart from a transient failure.
const withStatus = (data, status) =>
  data && typeof data === "object" ? { ...data, httpStatus: status } : data;

export default class Request {
  constructor(headers) {
    cors();
    this.http = axios.create({
      baseURL: process.env.REACT_APP_URL,
      withCredentials: false,
    });

    this.http.interceptors.request.use(async (config) => {
      let token = Auth.getToken()?.token;
      if (headers?.responseType) {
        config.responseType = headers?.responseType;
      }
      const hasExplicitAuth = headers && "Authorization" in headers;
      config.headers = {
        ...(!hasExplicitAuth && { Authorization: token ? `Bearer ${token}` : "" }),
        ...headers,
      };
      // Replay after a refresh (see the 401 handler below): `headers` still
      // carries the token the server just rejected, so swap in the new one.
      if (config._retriedAfterRefresh && token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });
    this.http.interceptors.response.use(
      async (response) => {
        return response;
      },
      async (error) => {
        console.error("error", error);
        if (error.response) {
          // forbidden: 403
          // unauthrized: 401
          // not found: 400
          if (error.response.status && error.response.status === 403) {
            return Promise.reject(withStatus(error.response.data, 403));
          } else if (error.response.status && error.response.status === 401) {
            const config = error.config;
            const isRefreshEndpoint = config?.url?.includes("refresh-token");
            if (!isRefreshEndpoint) {
              Emitter.emit(EventTypes.INVALID_TOKEN);
              // The server rejected the access token itself, not just an
              // expired one. Refresh now and replay once, instead of leaving
              // the user looking logged in while every authed call fails until
              // expire_date. A rejected refresh signs out (Auth._doRefresh).
              const sentToken = /^Bearer \S/.test(config?.headers?.Authorization || "");
              if (sentToken && !config._retriedAfterRefresh) {
                const newToken = await Auth.refreshNow();
                if (newToken) {
                  config._retriedAfterRefresh = true;
                  return this.http(config);
                }
              }
            }
            return Promise.reject(withStatus(error.response.data, 401));
          } else {
            let errorData = error?.response?.data;
            if (errorData) {
              if (errorData?.message?.length > 1) {
                // toast.error(errorData.message);
              } else {
                // toast.error(errorData.errorDetail);
              }
            }
            return Promise.reject(errorData);
          }
        } else if (error.request) {
          return Promise.reject(error.request);
        } else {
          return Promise.reject(error);
        }
      }
    );
    for (const method of ["get", "post", "put", "delete"]) {
      this[method] = this.http[method];
    }
  }
}